import React from 'react';
import PropTypes from 'prop-types';
import {NeuroMessage} from '@ignitesales/neuro-application';

const WelcomeTitle = ({ tagName = 'h1' }) => {
    return ( <NeuroMessage id='landing.title' tagName={tagName} /> );
};
WelcomeTitle.propTypes = {
    tagName: PropTypes.string
};

const WelcomeMessage = ({ tagName = 'p' }) => {
    return ( <NeuroMessage id='landing.message' tagName={tagName} shouldHideIfNotFound={true} /> );
};
WelcomeMessage.propTypes = {
    tagName: PropTypes.string
};

const GuideNameMessage = ({ tagName = 'span' }) => {
    return ( <NeuroMessage id='guide.name' tagName={tagName} /> );
};
GuideNameMessage.propTypes = {
    tagName: PropTypes.string
};

export {
    GuideNameMessage,
    WelcomeTitle,
    WelcomeMessage
};
